export function isExternalLink (link) {
  const regex = new RegExp('https?://*')
  return regex.test(link)
}
